/**
 * Кошелёк игрока (§Т2.4).
 */

import type { DebtTier } from "@hive/shared";

import { apiFetch } from "./client.js";

export type ServerWalletView = {
  readonly hive: number;
  readonly cash: number;
  readonly debt: number;
  readonly held: number;
  readonly effective: number;
  readonly debtTier: DebtTier;
  readonly recoveryDaysLeft: number;
};

export type LedgerEntryView = {
  readonly id: number;
  readonly op: string;
  readonly amount: number;
  readonly currency: "hive" | "cash";
  readonly hexId: string | null;
  readonly createdAt: string;
  readonly params: Record<string, unknown>;
};

export type LedgerResponse = {
  readonly entries: LedgerEntryView[];
};

export type DebtItemView = {
  readonly hexId: string;
  readonly ownerName: string;
  readonly amount: number;
  readonly dueAt: string;
};

export type DebtsResponse = {
  readonly debts: DebtItemView[];
};

export type EconomySummaryView = {
  readonly ecoDayEndsAt: string;
  readonly incomeHex: number;
  readonly incomeHearth: number;
  readonly incomeLodgers: number;
  readonly incomeWork: number;
  readonly tributePaid: number;
  readonly tributeReceived: number;
  readonly tributeCap: number;
  readonly tributeCapLeft: number;
};

export type LedgerQuery = {
  readonly from?: string;
  readonly to?: string;
  readonly op?: string;
};

export async function fetchWallet(
  token: string,
  signal?: AbortSignal,
): Promise<ServerWalletView> {
  return apiFetch<ServerWalletView>("/wallet", { token, ...(signal ? { signal } : {}) });
}

export async function fetchLedger(
  token: string,
  query: LedgerQuery = {},
  signal?: AbortSignal,
): Promise<LedgerResponse> {
  const params = new URLSearchParams();
  if (query.from) params.set("from", query.from);
  if (query.to) params.set("to", query.to);
  if (query.op) params.set("op", query.op);
  const qs = params.toString();
  const path = qs ? `/wallet/ledger?${qs}` : "/wallet/ledger";
  return apiFetch<LedgerResponse>(path, { token, ...(signal ? { signal } : {}) });
}

export async function fetchDebts(
  token: string,
  signal?: AbortSignal,
): Promise<DebtsResponse> {
  return apiFetch<DebtsResponse>("/wallet/debts", { token, ...(signal ? { signal } : {}) });
}

export async function fetchEconomySummary(
  token: string,
  signal?: AbortSignal,
): Promise<EconomySummaryView> {
  return apiFetch<EconomySummaryView>("/economy/summary", {
    token,
    ...(signal ? { signal } : {}),
  });
}
